import { render } from "./WnPages.vue?vue&type=template&id=4baee187&scoped=true"
import script from "./WnPages.vue?vue&type=script&lang=js"
export * from "./WnPages.vue?vue&type=script&lang=js"

import "./WnPages.vue?vue&type=style&index=0&id=4baee187&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4baee187"]])

export default __exports__